export const chatNotification = {
  admin: "ADMIN",
  regular_and_admin: "REGULAR",
  current_user: "YOU",
  new: "新規",
  confirmed: "確認済み",
};
